const API_BASE = import.meta.env.VITE_API_URL || "http://localhost:3028";

export async function fetchSettings() {
  const response = await fetch(`${API_BASE}/api/settings`);
  if (!response.ok) throw new Error("Failed to fetch settings");
  return response.json();
}

export async function saveSettings(settings: any) {
  const response = await fetch(`${API_BASE}/api/settings`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ settings }),
  });
  if (!response.ok) throw new Error("Failed to save settings");
  return response.json();
}

export async function uploadFile(file: File): Promise<string> {
  const formData = new FormData();
  formData.append("image", file);

  const response = await fetch(`${API_BASE}/api/upload`, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) throw new Error("Upload failed");
  const data = await response.json();
  // Return absolute URL using the configured API_BASE (your domain)
  return `${API_BASE}${data.url}`;
}

export async function saveChatSession(sessionId: string, name: string, email: string) {
  const response = await fetch(`${API_BASE}/api/chat/session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ sessionId, name, email }),
  });
  return response.json();
}

export async function sendChatMessage(sessionId: string, sender: 'user' | 'admin' | 'bot', text: string) {
  const response = await fetch(`${API_BASE}/api/chat/messages`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ sessionId, sender, text }),
  });
  return response.json();
}

export async function fetchChatMessages(sessionId: string) {
  const response = await fetch(`${API_BASE}/api/chat/messages/${sessionId}`);
  return response.json();
}

export async function fetchAdminConversations() {
  const response = await fetch(`${API_BASE}/api/chat/admin/conversations`);
  return response.json();
}

export async function markChatAsRead(sessionId: string) {
  const response = await fetch(`${API_BASE}/api/chat/admin/read/${sessionId}`, { method: "PUT" });
  return response.json();
}

export async function apiFetchOrders() {
  const response = await fetch(`${API_BASE}/api/orders`);
  if (!response.ok) throw new Error("Failed to fetch orders");
  return response.json();
}

export async function apiUpdateOrderStatus(id: number, status: string) {
  const response = await fetch(`${API_BASE}/api/orders/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ payment_status: status })
  });
  if (!response.ok) throw new Error("Failed to update order");
  return response.json();
}

export async function apiCreatePaymentIntent(data: any) {
  const response = await fetch(`${API_BASE}/api/create-payment-intent`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return response.json();
}

export async function apiCreateOrder(data: any) {
  const response = await fetch(`${API_BASE}/api/orders`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return response.json();
}
